import { v4 as uuid4 } from 'uuid';
import type { NodeDefault } from '../../types';
import { BlockEnum } from '../../types';
import {
  // ALL_CHAT_AVAILABLE_BLOCKS,
  ALL_COMPLETION_AVAILABLE_BLOCKS,
} from '../../blocks';
import type { AssignmentNodeType } from './types';

const nodeDefault: NodeDefault<AssignmentNodeType> = {
  defaultValue: {
    detail: {
      id: uuid4(),
      hash: 1,
      title: '标题',
      station: {
        id: '',
        name: ''
      },
      businessTags: ['主场景'],
      bindBusinessScenario: {
        id: '',
        name: '',
      },
    },
    status: 'online',
  },
  getAvailablePrevNodes() {
    return ALL_COMPLETION_AVAILABLE_BLOCKS.filter(
      (type) => type !== BlockEnum.End && type !== BlockEnum.Mirror,
    );
  },
  getAvailableNextNodes(isChatMode: boolean = false) {
    return ALL_COMPLETION_AVAILABLE_BLOCKS;
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
